module.exports = __webpack_public_path__ + "static/media/render_only.2b200109.jpg";